import React from "react";
import HTML from "../../assets/html.png";
import CSS from "../../assets/css.png";
import JAVASCRIPT from "../../assets/javascript.png";
import REACT from "../../assets/react.png";
import PYTHON from "../../assets/python.png";
import GITHUB from "../../assets/github.png";
import { SkillsList } from "./SkillsList";

export const Skills = () => {
  return (
    <div name="skills" className="w-full h-screen bg-navbar text-gray-300">
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div>
          <p className="text-4xl font-bold inline border-b-4 border-pink-600 ">
            Skills
          </p>
          <p className="py-4">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-4 text-center py-8">
          <SkillsList skillSource={HTML} skillName="HTML" />
          <SkillsList skillSource={CSS} skillName="CSS" />
          <SkillsList skillSource={JAVASCRIPT} skillName="JAVASCRIPT" />
          <SkillsList skillSource={REACT} skillName="REACT" />
          <SkillsList skillSource={PYTHON} skillName="PYTHON" />
          <SkillsList skillSource={GITHUB} skillName="GITHUB" />
        </div>
      </div>
    </div>
  );
};
